<script type="text/javascript">
  export default {
    props: ['type', 'pc', 'website'],
    data() {
      return {
        default_content: {
          type: 'services-quiz',
          title: 'Services quiz',
          active: 1,
          image: '',
          color: 'gray-100',
          opacity: '',
          pad_t: '5',
          pad_r: '0',
          pad_b: '5',
          pad_l: '0',
          icon: '',
          icon_color: 'revinre',
          h2: '',
          h2_color: '',
          h2_desc: '',
          h2_desc_color: '',
          pre_btn: [],
          start_bg_color: 'lighten-success',
          start_full_width: 1,
          start_shadow: 1,
          start_border_size: '1',
          start_border_color: 'success',
          start_image: '/fm/revinre/clip art/options.png',
          start_image_alt: 'Need help deciding?',
          start_title: 'Need help deciding?',
          start_title_color: 'black',
          start_desc: "Not sure which option is best for you? We've created a short questionnaire to help point you in the right direction.",
          start_desc_color: 'black',
          start_btn_text: 'Start the quiz',
          start_btn_pre_icon: '',
          start_btn_post_icon: 'ri:test-tube-line',
          start_btn_color: 'black',
          start_btn_full_width: '',

          quiz_bg_color: 'white',
          quiz_full_width: 1,
          quiz_shadow: 0,
          quiz_border_size: '',
          quiz_border_color: '',
          quiz_title_color: 'black',
          quiz_btn_color: 'success',

          results: [],
          questions: [],
          post_btn: [],
        },

        start_quiz: 'start',
        quiz_step: 0,
        quiz_complete: 0,
        final_result: {},
      }
    },
    created() {
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }
      if(!this.pc.pre_btn) { this.pc.pre_btn = []; this.$forceUpdate(); }
      if(!this.pc.post_btn) { this.pc.post_btn = []; this.$forceUpdate(); }
      if(!this.pc.results) { this.pc.results = []; this.$forceUpdate(); }
      if(!this.pc.questions) { this.pc.questions = []; this.$forceUpdate(); }
    },
    methods: {
      add_to_count(id) {
        for(var i in this.pc.results) { if(this.pc.results[i].id == id) {
          if(!this.pc.results[i].count) { this.pc.results[i].count = 1; } else { this.pc.results[i].count = this.pc.results[i].count + 1; break; }
        } }
        this.$forceUpdate();

        if(this.pc['questions'][this.quiz_step + 1]) {
          this.quiz_step = this.quiz_step + 1;
        } else {
          var highest = 0;
          for(var i in this.pc.results) { if(this.pc.results[i].count && this.pc.results[i].count > highest) { this.final_result = this.pc.results[i]; } }
          this.start_quiz = 'results';
        }
      },
    }
  }
</script>

<template>
  <section>

    <div v-if="type == 'editor'">
      <div class="p-3">
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display this section on the live website?"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section background and padding :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.image" Title="Background image URL :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.opacity" Min="0" Max="10" Title="Background color opacity :" v-tippy content="Background color transparency (0 through 10)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_t" Min="0" Max="20" Title="Top padding :" v-tippy content="Padding for the top of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_r" Min="0" Max="20" Title="Right padding :" v-tippy content="Padding for the right of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_b" Min="0" Max="20" Title="Bottom padding :" v-tippy content="Padding for the bottom of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_l" Min="0" Max="20" Title="Left padding :" v-tippy content="Padding for the left of the section (0 through 20)"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section H2 title :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.icon" Title="Section icon :" v-tippy content="Section icon"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.icon_color" Title="Section icon color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.h2" Title="H2 title :" v-tippy content="Section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_color" Title="H2 title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="Textarea" v-model="pc.h2_desc" Title="H2 description :" v-tippy content="Section description appearing below the section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_desc_color" Title="H2 description color : " :Options="theme_colors"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Top buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.pre_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.pre_btn" :key="'f1'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.pre_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.pre_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add result</button>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Start button box :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.start_full_width" Title="Full width : " :Options="[{name:'Yes',value:1},{name:'No',value:0}]"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.start_shadow" Title="Box shadow : " :Options="[{name:'Yes',value:1},{name:'No',value:0}]"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.start_bg_color" Title="Background color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.start_border_size" Title="Border size : " Min="0" Max="10"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.start_border_color" Title="Border color : " :Options="theme_colors"></w-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.start_image" Title="Image URL :"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.start_image_alt" Title="Image alt text :"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.start_title" Title="Title :"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.start_title_color" Title="Title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="Textarea" v-model="pc.start_desc" Title="Description :"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.start_desc_color" Title="H2 description color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String List, Single" v-model="pc.start_btn_color" Title="Button color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String List, Single" v-model="pc.start_btn_full_width" Title="Button full width : " :Options="[{name:'Yes',value:1},{name:'No',value:0}]"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String" v-model="pc.start_btn_pre_icon" Title="Button pre icon :"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String" v-model="pc.start_btn_text" Title="Button text :"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String" v-model="pc.start_btn_post_icon" Title="Button post icon :"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Quiz box :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.quiz_full_width" Title="Full width : " :Options="[{name:'Yes',value:1},{name:'No',value:0}]"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.quiz_shadow" Title="Box shadow : " :Options="[{name:'Yes',value:1},{name:'No',value:0}]"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.quiz_bg_color" Title="Background color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.quiz_border_size" Title="Border size : " Min="0" Max="10"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.quiz_border_color" Title="Border color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.quiz_title_color" Title="Title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.quiz_btn_color" Title="Button color : " :Options="theme_colors"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Quiz Results :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.results">
            <transition-group tag="div">
              <div v-for="(result, result_i) in pc.results" :key="'r'+result_i" class="border-bottom border-light py-4">
                <div class="row">
                  <div class="col">
                    <w-field SimpleDataType="String" v-model="result.title" Title="Title : "></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <label>.</label>
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.results.splice(result_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <label>.</label>
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="result.id" Title="Result ID :"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String List, Single" v-model="result.btn_color" Title="Button color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="result.btn_pre_icon" Title="Button pre icon :"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="result.btn_text" Title="Button text :"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="result.btn_post_icon" Title="Button post icon :"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="result.btn_url" Title="Button URL :"></w-field>
                  </div>
                  <div class="col-sm-12">
                    <label>Description :</label>
                    <CkRichEditor v-model="result.desc" v-tippy content=""></CkRichEditor>
                  </div>
                </div>
                <hr>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.results.push({
            title: '',
            id: '',
            btn_color: '',
            btn_pre_icon: '',
            btn_text: '',
            btn_post_icon: '',
            btn_url: '',
            desc: '',
            count: 0,
          }); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add result</button>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Quiz Questions :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.questions">
            <transition-group tag="div">
              <div v-for="(question, question_i) in pc.questions" :key="'q'+question_i" class="border-bottom border-light py-4">
                <div class="row">
                  <div class="col">
                    <w-field SimpleDataType="String" v-model="question.title" Title="Title : "></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <label>.</label>
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.questions.splice(question_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <label>.</label>
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <label>Description :</label>
                    <CkRichEditor v-model="question.desc" v-tippy content=""></CkRichEditor>
                  </div>
                </div>
                <label>Answers :</label>
                <draggable handle=".handle2" v-bind="{animation: 200}" v-model="question.answers">
                  <transition-group tag="div">
                    <div v-for="(answer, answer_i) in question.answers" :key="'a'+answer_i">
                      <div class="row m-0 align-items-end">
                        <div class="col-4 p-0">
                          <w-field SimpleDataType="String" v-model="answer.title" Title="Title :"></w-field>
                        </div>
                        <div class="col p-0">
                          <w-field SimpleDataType="String" v-model="answer.result_id" Title="Result ID :"></w-field>
                        </div>
                        <div class="_w-40 pb-2">
                          <button class="btn btn-white" type="button" v-tippy content="Delete" @click="question.answers.splice(answer_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                        </div>
                        <div class="_w-40 pb-2">
                          <button class="btn btn-white handle2" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                        </div>
                      </div>
                    </div>
                  </transition-group>
                </draggable>
                <button class="btn btn-sm btn-white" type="button" @click="question.answers.push({
                  title: '',
                  result_id: '',
                }); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add answer</button>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.questions.push({
            title: '',
            desc: '',
            answers: [],
          }); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add question</button>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Bottom buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.post_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.post_btn" :key="'f2'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.post_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.post_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

      </div>
    </div>

    <div v-else class="container-fluid">
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+(pc['image'] ? fullurlencode(pc['image']) : '')+')'"></div>
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1" :class="'bg-'+pc['color']+' _o-'+pc['opacity']"></div>
      <div class="m_py-35" :class="'pt-'+pc['pad_t']+' pr-'+pc['pad_r']+' pb-'+pc['pad_b']+' pl-'+pc['pad_l']">

        <div v-if="pc['icon'] || pc['h2'] || pc['h2_desc']" class="text-center _w-m-900 mx-auto mb-5">
          <Icon v-if="pc['icon']" :icon="pc['icon']" height="45" class="mb-2" :class="'text-'+pc['icon_color']"></Icon>
          <h2 v-if="pc['h2']" class="mb-3" :class="'text-'+pc['h2_color']" data-aos="fade-zoom-in">{{pc['h2']}}</h2>
          <p v-if="pc['h2_desc']" class="text-pre-wrap" :class="'text-'+pc['h2_desc_color']" data-aos="fade-zoom-in">{{pc['h2_desc']}}</p>
        </div>

        <div v-if="pc['pre_btn'] && pc['pre_btn'].length" class="text-center mb-5">
          <a v-for="(btn, btn_i) in pc['pre_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

        <transition name="fade" tag="div" mode="out-in">
          <div v-if="start_quiz == 'start'" class="mx-auto" :class="'bg-'+pc['start_bg_color']+(pc['start_border_size'] ? ' border _b-s-'+pc['start_border_size']+' border-'+pc['start_border_color'] : '')+(pc['start_full_width'] ? '' : ' _w-m-900')+(pc['start_shadow'] ? ' card' : '')" key="1">
            <div class="_w-m-900 mx-auto">
              <div class="row m-0">
                  <div v-if="pc['start_image']" class="col-sm-4 px-4">
                    <div class="">
                      <img data-aos="fade-zoom-in" :src="formatImage(pc['start_image'])" :alt="pc['start_image_alt']" class="img-fluid mx-auto d-block">
                    </div>
                  </div>
                  <div class="col p-4">
                    <h3 v-if="pc['start_title']" class="h2 mb-3" :class="'text-'+pc['start_title_color']" data-aos="fade-zoom-in">{{pc['start_title']}}</h3>
                    <p v-if="pc['start_desc']" class="mb-4" :class="'text-'+pc['start_desc_color']" data-aos="fade-zoom-in">{{pc['start_desc']}}</p>
                    <div v-if="pc['start_btn_text'] || pc['start_btn_pre_icon'] || pc['start_btn_post_icon']" data-aos="fade-zoom-in">
                      <button type="button" class="btn btn-lg" :class="'btn-'+pc['start_btn_color']+(pc['start_btn_full_width'] ? ' btn-block' : '')" @click="start_quiz = 'quiz'">
                        <Icon v-if="pc['start_btn_pre_icon']" :icon="pc['start_btn_pre_icon']" height="20"></Icon>
                        <span v-if="pc['start_btn_pre_icon'] && pc['start_btn_text']" class="border-left mx-3"></span>
                        {{ pc['start_btn_text'] }}
                        <span v-if="pc['start_btn_post_icon'] && pc['start_btn_text']" class="border-left mx-3"></span>
                        <Icon v-if="pc['start_btn_post_icon']" :icon="pc['start_btn_post_icon']" height="20"></Icon>
                      </button>
                    </div>
                  </div>
                </div>
            </div>
          </div>

          <div v-else-if="start_quiz == 'quiz'" class="mx-auto" :class="'bg-'+pc['quiz_bg_color']+(pc['quiz_border_size'] ? ' border _b-s-'+pc['quiz_border_size']+' border-'+pc['quiz_border_color'] : '')+(pc['quiz_full_width'] ? '' : ' _w-m-900')+(pc['quiz_shadow'] ? ' card' : '')" key="2">
            <div class="_w-m-900 mx-auto py-5 text-center">
              <transition name="fade" tag="div" mode="out-in">
                <div v-if="pc['questions'][quiz_step]" :key="'st'+quiz_step">
                  <h3 class="_f-s-40 mb-5">{{ pc['questions'][quiz_step]['title'] }}</h3>
                  <div class="mb-5" v-html="pc['questions'][quiz_step]['desc']"></div>
                  <div v-if="pc['questions'][quiz_step]['answers'] && pc['questions'][quiz_step]['answers'].length" class="mt-5">
                    <button v-for="(answer, answer_i) in pc['questions'][quiz_step]['answers']" :key="answer_i" type="button" class="btn btn-lg btn-block _w-m-500 mx-auto font-weight-bold mb-2" @click="add_to_count(answer['result_id'])" :class="(pc['quiz_btn_color'] ? 'btn-'+pc['quiz_btn_color'] : 'btn-outline-black')">
                      {{ answer['title'] }}
                    </button>
                  </div>
                </div>
              </transition>
            </div>
          </div>

          <div v-else-if="start_quiz == 'results'" class="mx-auto" :class="'bg-'+pc['quiz_bg_color']+(pc['quiz_border_size'] ? ' border _b-s-'+pc['quiz_border_size']+' border-'+pc['quiz_border_color'] : '')+(pc['quiz_full_width'] ? '' : ' _w-m-900')+(pc['quiz_shadow'] ? ' card' : '')" key="3">
            <div class="_w-m-900 mx-auto py-6 text-center">
              <div v-if="final_result['title']">
                <h3 class="_f-s-40 mb-5">{{ final_result['title'] }}</h3>
                <div class="mb-5" v-html="final_result['desc']"></div>
                <a v-if="final_result['btn_pre_icon'] || final_result['btn_text'] || final_result['btn_post_icon']" :href="final_result['btn_url']" class="btn btn-lg" :class="'btn-'+final_result['btn_color']">
                  <Icon v-if="final_result['btn_pre_icon']" :icon="final_result['btn_pre_icon']" height="20"></Icon>
                  <span v-if="final_result['btn_pre_icon'] && final_result['btn_text']" class="border-left mx-3"></span>
                  {{ final_result['btn_text'] }}
                  <span v-if="final_result['btn_post_icon'] && final_result['btn_text']" class="border-left mx-3"></span>
                  <Icon v-if="final_result['btn_post_icon']" :icon="final_result['btn_post_icon']" height="20"></Icon>
                </a>
              </div>
            </div>
          </div>

        </transition>

        <!-- <div class="row justify-content-center">
          <div class="col _w-m-900">
            <div class="card" :class="'bg-'+pc['start_bg_color']+(pc['start_border_size'] ? ' border _b-s-'+pc['start_border_size']+' border-'+pc['start_border_color'] : '')">
              <div class="row m-0">
                <div v-if="pc['start_image']" class="col-sm-4 px-4">
                  <div class="">
                    <img data-aos="fade-zoom-in" :src="formatImage(pc['start_image'])" :alt="pc['start_image_alt']" class="img-fluid mx-auto d-block">
                  </div>
                </div>
                <div class="col p-4">
                  <h3 v-if="pc['start_title']" class="h2 mb-3" :class="'text-'+pc['start_title_color']" data-aos="fade-zoom-in">{{pc['start_title']}}</h3>
                  <p v-if="pc['start_desc']" class="mb-4" :class="'text-'+pc['start_desc_color']" data-aos="fade-zoom-in">{{pc['start_desc']}}</p>
                  <div v-if="pc['start_btn_text'] || pc['start_btn_pre_icon'] || pc['start_btn_post_icon']" data-aos="fade-zoom-in">
                    <button type="button" class="btn btn-lg" :class="'btn-'+pc['start_btn_color']+(pc['start_btn_full_width'] ? ' btn-block' : '')">
                      <Icon v-if="pc['start_btn_pre_icon']" :icon="pc['start_btn_pre_icon']" height="20"></Icon>
                      <span v-if="pc['start_btn_pre_icon'] && pc['start_btn_text']" class="border-left mx-3"></span>
                      {{ pc['start_btn_text'] }}
                      <span v-if="pc['start_btn_post_icon'] && pc['start_btn_text']" class="border-left mx-3"></span>
                      <Icon v-if="pc['start_btn_post_icon']" :icon="pc['start_btn_post_icon']" height="20"></Icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div v-if="pc['post_btn'] && pc['post_btn'].length" class="text-center mt-5">
          <a v-for="(btn, btn_i) in pc['post_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

      </div>
    </div>
  </section>

</template>
